import { render, staticRenderFns } from "./BrandThumbnailCard.vue?vue&type=template&id=09a34464&scoped=true&"
import script from "./BrandThumbnailCard.vue?vue&type=script&lang=ts&"
export * from "./BrandThumbnailCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandThumbnailCard.vue?vue&type=style&index=0&id=09a34464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a34464",
  null
  
)

export default component.exports